<template>
  <div class="ch-filter-in-detail">
    <doorlocks-mobile-key-filter class="ma-0 mb-3"></doorlocks-mobile-key-filter>
    <doorlocks-mobile-key-list></doorlocks-mobile-key-list>
  </div>
</template>

<script>
  import DoorlocksMobileKeyFilter from '@/components/admin/doorlocks/DoorlocksMobileKeyFilter';
  import DoorlocksMobileKeyList from '@/components/admin/doorlocks/DoorlocksMobileKeyList';

  export default {
    data() {
      return {
        id: null,
      };
    },
    created() {
      this.id = this.$route.params.id;
    },
    components: {
      DoorlocksMobileKeyFilter, DoorlocksMobileKeyList,
    },
  };
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/doorlocks/DoorlocksMobileKey.vue